import firebase from "firebase/app";
import "firebase/firestore"; 
import "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    databaseURL: process.env.VUE_APP_FIREBASE_RTDB_URL,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
  try {
    analytics = firebase.analytics();
    
    // Enable debug mode in development for real-time event viewing
    if (process.env.NODE_ENV === 'development') {
      // Enable debug mode - events will appear in DebugView within seconds
      // You can also enable via URL: add ?firebase_analytics_debug=true to your URL
      try {
        // For web, debug mode is enabled via URL parameter or browser extension
        // Check if debug parameter is in URL
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('firebase_analytics_debug') === 'true') {
          console.log('🔍 Firebase Analytics Debug Mode enabled via URL parameter');
        }
      } catch (e) {
        // Ignore errors
      }
    }
    
    // Verify analytics is initialized
    if (analytics) {
      console.log('✅ Firebase Analytics initialized successfully');
      console.log('Measurement ID:', firebaseConfig.measurementId);
      console.log('💡 Tip: Add ?firebase_analytics_debug=true to URL for DebugView, or use Google Analytics Debugger extension');
    }
  } catch (error) {
    console.error('❌ Firebase Analytics initialization failed:', error);
  }
} else {
  if (typeof window !== 'undefined') {
    console.warn('⚠️ Firebase Analytics not initialized: measurementId is missing');
  }
}

export default app;
export { analytics };